var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocSelectorPassportSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 10.0001H32.002H38.002V44.0001H10.002V10.0001Z",
    stroke: "#A12885",
    strokeWidth: 1.4056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 10.0001L32.002 4.00012V10.0001",
    stroke: "#A12885",
    strokeWidth: 1.4056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.001 28.0001C26.2101 28.0001 28.001 26.2093 28.001 24.0001C28.001 21.791 26.2101 20.0001 24.001 20.0001C21.7918 20.0001 20.001 21.791 20.001 24.0001C20.001 26.2093 21.7918 28.0001 24.001 28.0001Z",
    stroke: "#A12885",
    strokeWidth: 1.4056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 34H28.001",
    stroke: "#A12885",
    strokeWidth: 1.4056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocSelectorPassportSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc-selector-passport-selected.c46067a6d0594f4a889b70b49ec2211a.svg";